import React from 'react';
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";

const CortexRenavamContent = ({data, printRef, headerSelected, filters}) => {
    const decamelize = (str = '') => {
        const separator = ' ';

        str = str
            .replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
            .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2')
            .toLowerCase();

        return str[0].toUpperCase() + str.slice(1);
    }

    const translateKey = (key) => {
        const model = {
            alarme: 'Alarme',
            anoFabricacao: 'Ano de Fabricação',
            anoModelo: 'Ano do Modelo',
            arrendatario: 'Arrendatário',
            enderecoArrendatario: 'Endereço do Arrendatário',
            nomeArrendatario: 'Nome do Arrendatário',
            numeroDocumentoArrendatario: 'Nº Documento do Arrendatário',
            placa: 'Placa',
            tipoDocumentoArrendatario: 'Tipo de Documento do Arrendatário',
            capacidadeMaximaCarga: 'Capacidade Máxima de Carga',
            capacidadeMaximaTracao: 'Capacidade Máxima de Tração',
            carroceria: 'Carroceria',
            chassi: 'Chassi',
            cilindrada: 'Cilindrada',
            codigoMunicipioEmplacamento: 'Código do Município do Emplacamento',
            codigoOrgaoSRF: 'Código do Órgão SRF',
            combustivel: 'Combustível',
            cor: 'Cor',
            dataAtualizacaoAlarme: 'Data de Atualização do Alarme',
            dataAtualizacaoRouboFurto: 'Data de Atualização de Roubo/Furto',
            dataAtualizacaoVeiculo: 'Data de Atualização do veículo',
            dataDeclaracaoImportacao: 'Data de Declaração da Importação',
            dataEmplacamento: 'Data do Emplacamento',
            dataLimiteRestricaoTributaria: 'Data Limite de Restrição Tributária',
            especie: 'Espécie',
            grupoVeiculo: 'Grupo do Veículo',
            indicadorRemarcacaoChassi: 'Indicador de Remarcação do Chassi',
            indicadorVeiculoLicenciadoCirculacao: 'Indicador de Veículo Licenciado em Circulação',
            lotacao: 'Lotação',
            marcaModelo: 'Marca/Modelo',
            municipioPlaca: 'Município da Placa',
            numeroCaixaCambio: 'Número da Caixa de câmbio',
            numeroCarroceria: 'Número da Carroceria',
            numeroDeclaracaoImportacao: 'Número de Declaração da Importação',
            numeroEixoAuxiliar: 'Número do Eixo Auxiliar',
            numeroEixoTraseiro: 'Número do Eixo Traseiro',
            numeroIdentificacaoFaturado: 'Número de Identificação Faturado',
            numeroIdentificacaoImportador: 'Número de Identificação Importador',
            numeroMotor: 'Número do Motor',
            pesoBrutoTotal: 'Peso Bruto Total',
            possuidor: 'Possuidor',
            enderecoPossuidor: 'Endereço do Possuidor',
            nomePossuidor: 'Nome do Possuidor',
            numeroDocumentoPossuidor: 'Número de Documento do Possuidor',
            tipoDocumentoPossuidor: 'Tipo de Documento do Possuidor',
            potencia: 'Potência',
            proprietario: 'Proprietário',
            enderecoProprietario: 'Endereço do Proprietário',
            nomeProprietario: 'Nome do Proprietário',
            numeroDocumentoProprietario: 'Número de Documento do Proprietário',
            tipoDocumentoProprietario: 'Tipo de Documento do Proprietário',
            quantidadeEixo: 'Quantidade de Eixos',
            renavam: 'RENAVAM',
            restricao: 'Restrição',
            anoBO: 'Ano do BO',
            dataOcorrencia: 'Data da Ocorrência',
            dddContato: 'DDD do Contato',
            municipioBO: 'Município do BO',
            naturezaOcorrencia: 'Natureza da Ocorrência',
            nomeDeclarante: 'Nome do Declarante',
            numeroBO: 'Número do BO',
            ramalContato: 'Ramal do Contato',
            telefoneContato: 'Telefone do Contato',
            ufBO: 'UF do BO',
            unidadePolicial: 'Unidade Policial',
            restricaoVeiculo1: 'Restrição do Veículo 1',
            restricaoVeiculo2: 'Restrição do Veículo 2',
            restricaoVeiculo3: 'Restrição do Veículo 3',
            restricaoVeiculo4: 'Restrição do Veículo 4',
            rouboFurto: 'Roubo/Furto',
            tipoDocumentoFaturado: 'Tipo de Documento Faturado',
            tipoMontagem: 'Tipo de Montagem',
            tipoVeiculo: 'Tipo do Veículo',
            ufEmplacamento: 'UF do Emplacamento',
            ufFatura: 'UF da Fatura',
            quaantidadeRestricoesBaseEmplacamento: 'Quantidade Restrições Base Emplacamento',
        };

        if (key in model) {
            return model[key];
        } else {
            return decamelize(key);
        }
    }

    const buildTBodyFromObject = (obj = {}, index) => {
        let list = [];
        Object.entries(obj).map(([key, value]) => {
            list.push(<li key={"custom-li-" + key} className="custom-li">{translateKey(key) + ': ' + value}</li>);
        });

        return (
            <ul key={index ? "list-disc-" + index : ""} className="mb-4 !list-disc">
                { list }
            </ul>
        );
    }

    return (
        <PrintTemplate title={"CÓRTEX - RENAVAM"} ref={printRef} entity={headerSelected} printHeaderClassname={"hidden print:block"} printFooterClassname={"hidden print:block"}>
            <section className={"hidden print:flex mb-2 gap-4"}>
                <p>Tipo: <strong>{filters.type?.label}</strong></p>
                <p>Valor: <strong>{filters.value}</strong></p>
            </section>

            <table className={"border border-gray-200"}>
                <thead>
                <tr className="bg-[#f5f5f6] text-left">
                    <th className={"p-[6.4px]"} style={{width: "30%"}}>Placa</th>
                    <th className={"p-[6.4px]"} style={{width: "70%"}}>{data?.placa ?? ''}</th>
                </tr>
                </thead>
                <tbody className="bg-white [&>tr:nth-child(odd)]:bg-gray-100">
                {
                    Object.entries(data).map(([key, value]) => {
                        let valueData = "";

                        if (key === 'placa') {
                            return;
                        }

                        if (typeof value === 'string' || value instanceof String) {
                            valueData = value;
                        } else if (value instanceof Object && value.constructor === Object) {
                            valueData = buildTBodyFromObject(value);
                        } else if (Array.isArray(value)) {
                            valueData = value.map((obj, i) => buildTBodyFromObject(obj, i))

                            if (value.length === 0) {
                                valueData = "";
                            }
                        } else {
                            valueData = value;
                        }

                        return (
                            <tr className="table-break-word" key={key}>
                                <td className={"p-[6.4px]"}>{ translateKey(key) }</td>
                                <td className={"p-[6.4px]"}>{ valueData }</td>
                            </tr>
                        )
                    })
                }
                </tbody>
            </table>
        </PrintTemplate>
    );
};

export default CortexRenavamContent;